import React from 'react';

import { TableDirection } from '../../../types';
import { TableContext } from '../../context/TableContext';

interface Props {
  direction?: TableDirection;
  children: React.ReactNode;
}

export const Table: React.FC<Props> = ({
  direction = TableDirection.Auto,
  children,
}) => {
  return (
    <TableContext.Provider value={direction}>{children}</TableContext.Provider>
  );
};
